/**
 * Parse a stored ``control_state``. Returns null for anything this build
 * can't replay — absent, unparseable, or another version — so a
 * forward-incompatible payload degrades to "the view applies nothing"
 * instead of throwing inside a render.
 */
export function parseVersionedPayload<T extends { version: number }>(
  controlState: string | null | undefined,
  version: number
): T | null {
  if (!controlState) return null;
  try {
    const parsed = JSON.parse(controlState) as T;
    return parsed.version === version ? parsed : null;
  } catch {
    return null;
  }
}

/** Which of ``all``'s sections a payload carries. */
export function sectionsPresent<S extends object>(
  payload: { [K in keyof S]?: unknown },
  all: S
): { [K in keyof S]: boolean } {
  const present = {} as { [K in keyof S]: boolean };
  for (const key of Object.keys(all) as (keyof S)[]) {
    present[key] = Boolean(payload[key]);
  }
  return present;
}
